<script>
import BaseFilter from "./BaseFilter";
import { mapGetters } from "vuex";

export default {
  name: "SubstrateSearch",
  extends: BaseFilter,
  computed: {
    ...mapGetters({
      options: "substrates",
    }),
  },
  data() {
    return {
      placeholder: "Alle ondergronden",
      filtername: "ondergronden",
      type: "ondergronden",
    };
  },
};
</script>

